import { TextBoxOptionGroup } from '@components/TextBox';
import { Agency } from '@models/Agency';
import { Country } from '@models/Country';
import * as t from 'io-ts';

export const role = t.union([t.literal('admin'), t.literal('FCJapan'), t.literal('FCChina')]);

export const roles = role.types.map((l) => l.value);

export type Role = t.TypeOf<typeof role>;

export const rolesByCountry: Record<Country, Role[]> = {
  cn: ['admin', 'FCChina'],
  jp: ['admin', 'FCJapan'],
};

export const getRoleOptions = (agencies: Agency[]): TextBoxOptionGroup[] => {
  return roles.map((r) => {
    switch (r) {
      case 'admin':
        return { children: [{ label: 'admin', value: 'admin' }], label: 'admin' };
      case 'FCJapan':
        return { children: [{ label: 'FC Japan', value: 'FCJapan' }], label: 'FC Japan' };
      case 'FCChina':
        return {
          children: agencies.map((agency) => ({
            label: agency.name_en_short,
            value: `FCChina_${agency.id}`,
          })),
          label: 'FC China',
        };
      default:
        return { children: [{ label: r, value: r }], label: r };
    }
  });
};

export const mapRoleOptionToRole = (role: string) => {
  if (role.startsWith('FCChina')) {
    return 'FCChina';
  }
  return role;
};

export const mapRoleOptionToAgencyId = (role: string) => {
  if (role.startsWith('FCChina')) {
    const parsed = parseInt(role.split('_')[1], 10);
    if (!isNaN(parsed)) {
      return parsed;
    }
  }
  return undefined;
};

export const mapRoleToRoleOptionValue = (role?: string, agencyId?: number) => {
  if (role === 'FCChina') {
    return `FCChina_${agencyId}`;
  }
  return role;
};

export const mapRoleToRoleOptionLabel = (role?: string, agencyName?: string) => {
  switch (role) {
    case 'admin':
      return 'admin';
    case 'FCJapan':
      return 'FC Japan';
    case 'FCChina':
      return agencyName;
    default:
      return role;
  }
};
